var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "deliveryConfirm" } }, [
    _c("label", { staticClass: "text_size_big bold" }, [
      _vm._v("商品情報" + _vm._s(_vm.index))
    ]),
    _vm._v(" "),
    _c("div", [
      _c("section", { staticClass: "input_confirm3" }, [
        _c("img", { staticClass: "item_image", attrs: { src: _vm.itemImage } }),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("div", [_vm._v("メーカー名")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.itemData.makerData.corpName))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("シリーズ名")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.itemData.planEc.ecParamSeriesName))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("商品名")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.itemData.planEc.ecParamProductName))])
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isExistStyle,
                  expression: "isExistStyle"
                }
              ]
            },
            [
              _c("div", [_vm._v("スタイル名：")]),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.itemData.colorStyle.colorStyleName))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFillerEnable,
                  expression: "isFillerEnable"
                }
              ],
              staticClass: "list_item3"
            },
            [
              _c("div", [_vm._v("商品サイズ")]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "confirm_size" }, [
                  _c("span", [
                    _vm._v("W:" + _vm._s(_vm.itemData.planEc.ecParamW) + "mm")
                  ]),
                  _vm._v(" "),
                  _vm.itemData.planEc.ecParamW2
                    ? _c("span", [
                        _vm._v(
                          "W2:" + _vm._s(_vm.itemData.planEc.ecParamW2) + "mm"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "confirm_size" }, [
                  _c("span", [
                    _vm._v("H:" + _vm._s(_vm.itemData.planEc.ecParamH) + "mm")
                  ]),
                  _vm._v(" "),
                  _vm.itemData.planEc.ecParamH2
                    ? _c("span", [
                        _vm._v(
                          "H2:" + _vm._s(_vm.itemData.planEc.ecParamH2) + "mm"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "confirm_size" }, [
                  _c("span", [
                    _vm._v("D:" + _vm._s(_vm.itemData.planEc.ecParamD) + "mm")
                  ]),
                  _vm._v(" "),
                  _vm.itemData.planEc.ecParamD2
                    ? _c("span", [
                        _vm._v(
                          "D2:" + _vm._s(_vm.itemData.planEc.ecParamD2) + "mm"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.itemData.planEc.ecParamFillerLeft != undefined,
                          expression:
                            "itemData.planEc.ecParamFillerLeft!=undefined"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.labelLeftFiller) +
                          ":" +
                          _vm._s(_vm.itemData.planEc.ecParamFillerLeft) +
                          "mm"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.itemData.planEc.ecParamFillerRight != undefined,
                          expression:
                            "itemData.planEc.ecParamFillerRight!=undefined"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.labelRightFiller) +
                          ":" +
                          _vm._s(_vm.itemData.planEc.ecParamFillerRight) +
                          "mm"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.itemData.planEc.ecParamFillerCenter !=
                            undefined,
                          expression:
                            "itemData.planEc.ecParamFillerCenter!=undefined"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.labelCenterFiller) +
                          ":" +
                          _vm._s(_vm.itemData.planEc.ecParamFillerCenter) +
                          "mm"
                      )
                    ]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.itemData.doorColor
            ? _c("li", [
                _c("div", [_vm._v("扉カラー")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.doorColor.name))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemData.boxColor
            ? _c("li", [
                _c("div", [_vm._v("キャビネット/棚/脚カラー")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.boxColor.name))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemData.centerColor
            ? _c("li", [
                _c("div", [_vm._v("カウンターカラー")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.centerColor.name))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemData.planEc.ecParamShelfCount
            ? _c("li", [
                _vm._v(">\n          "),
                _c("div", [_vm._v(_vm._s(_vm.optShelfTitle))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.itemData.planEc.ecParamShelfCount) +
                      _vm._s(_vm.optShelfUnitTitle) +
                      "本"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.itemData.planEc.ecParamFillerCount
            ? _c("li", [
                _c("div", [_vm._v("追加フィラー")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.itemData.planEc.ecParamFillerCount) + "本")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("組立設置")]),
            _vm._v(" "),
            _vm.itemData.planEc.ecInfoOpExFlag === true
              ? _c("div", [_vm._v("あり")])
              : _vm._e(),
            _vm._v(" "),
            _vm.itemData.planEc.ecInfoOpExFlag === false
              ? _c("div", [_vm._v("なし")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_line" }, [
          _c("div", [_vm._v("ご注文数")]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.itemData.planEc.ecParamProductCount) + "点")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("小計（税込）:"),
            _c("span", [
              _vm._v(_vm._s(_vm.formatPrice(_vm.priceData.totalTax)))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "detail_btn2",
            on: {
              click: function($event) {
                _vm.onEstimate()
              }
            }
          },
          [_vm._v("図面/見積り")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c0f1e30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c0f1e30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/order/DcItemConfirm.vue
// module id = null
// module chunks = 